import type { QueryClient } from "@tanstack/react-query";

export const invalidateAdQueries = (queryClient: QueryClient) => {
  void queryClient.invalidateQueries({ queryKey: [{ entity: "V4AdvReportByAd" }] });
  void queryClient.invalidateQueries({ queryKey: [{ entity: "V4ProductAds" }] });
  void queryClient.invalidateQueries({ queryKey: ["ad_report"] });
};
